import { FC } from 'react';

import { Modal } from 'antd';

import { VideoTutorialsResponse } from '@/api/video-tutorials/video-tutorials';
import useMobile from '@/hooks/use-mobile';

import styles from './VideoHelper.module.scss';

type Props = {
	videoData: VideoTutorialsResponse;
	open: boolean;
	onCancel: () => void;
};

export const VideoHelperModal: FC<Props> = ({ onCancel, open, videoData }) => {
	const isMobile = useMobile();

	return (
		<Modal
			destroyOnClose
			title={<div className={styles.title}>{videoData?.title}</div>}
			open={open}
			onCancel={onCancel}
			rootClassName={styles.modal}
			width={1080}
			height="auto"
			footer={false}
			maskClosable={false}
		>
			<div className={styles.description}>{videoData?.description}</div>
			<iframe
				width="100%"
				height={isMobile ? 'auto' : 600}
				src={videoData?.videoUrl}
				frameBorder="0"
				allow="clipboard-write; autoplay"
				// @ts-ignore
				webkitAllowFullScreen
				mozallowfullscreen
				allowFullScreen
			/>
		</Modal>
	);
};
